/**
 * Ordered steps for the first-login onboarding tour.
 *
 * `target` is the value of a `data-tour="..."` attribute rendered somewhere in
 * the member area (see side-nav config). A `null` target renders a centred
 * step with no spotlight. Steps whose target cannot be found at runtime (e.g.
 * a permission-gated nav item) are skipped automatically.
 */
export const TOUR_STEPS = [
  {
    target: null,
    title: 'Welcome to Go-Mailer 👋',
    body: 'Let’s take a quick tour of the essentials so you can start reaching your customers right away.'
  },
  {
    target: 'dashboard',
    title: 'Your dashboard',
    body: 'Get a real-time pulse on your sends, deliverability and wallet balance the moment you log in.'
  },
  {
    target: 'contacts',
    title: 'Bring in your contacts',
    body: 'Import or add the people you want to reach — they’re the foundation of every campaign.'
  },
  {
    target: 'audiences',
    title: 'Organise into audiences',
    body: 'Group contacts into lists and segments so the right message always reaches the right people.'
  },
  {
    target: 'campaigns',
    title: 'Send your first campaign',
    body: 'Design an email or SMS, choose your audience and hit send — you only pay for what you send.'
  },
  {
    target: 'quick-actions',
    title: 'Quick Actions',
    body: 'Your most common tasks — create a contact, audience, campaign or report — are always one click away from here.'
  },
  {
    target: 'ai-assistant',
    title: 'Meet your AI Assistant',
    body: 'Stuck on something? Ask the AI Assistant any question about the platform and get an answer right away.'
  },
  {
    target: null,
    title: 'You’re all set 🎉',
    body: 'That’s the gist of it. Explore at your own pace — you can revisit tutorials any time from the side menu.'
  }
];
